export const ChevronDownIcon = ({ fill }) => {
  return (
    <svg width="12" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.12 0L8 6.18084L1.88 0L0 1.90283L8 10L16 1.90283L14.12 0Z" fill={fill ?? "#323232"} />
    </svg>
  );
};

export const ChevronUpIcon = ({ fill }) => {
  return (
    <svg width="12" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.88 10L8 3.89333L14.12 10L16 8.12L8 0.119999L1.64355e-07 8.12L1.88 10Z" fill={fill ?? "#323232"} />
    </svg>
  );
};

export const ChevronLeftIcon = ({ fill }) => {
  return (
    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.91585 14.3154L3.93323 8.07408L10.1615 2.07786L8.3196 0.160513L0.160661 7.99835L7.9985 16.1573L9.91585 14.3154Z"
        fill={fill ?? "#323232"}
      />
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z"
        fill="#323232"
      />
    </svg>
  );
};

export const EyeSlashIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 7C14.76 7 17 9.24 17 12C17 12.65 16.87 13.26 16.64 13.83L19.56 16.75C21.07 15.49 22.26 13.86 22.99 12C21.26 7.61 16.99 4.5 11.99 4.5C10.59 4.5 9.25 4.75 8.01 5.2L10.17 7.36C10.74 7.13 11.35 7 12 7ZM2 4.27L4.28 6.55L4.74 7.01C3.08 8.3 1.78 10.02 1 12C2.73 16.39 7 19.5 12 19.5C13.55 19.5 15.03 19.2 16.38 18.66L16.8 19.08L19.73 22L21 20.73L3.27 3L2 4.27ZM7.53 9.8L9.08 11.35C9.03 11.56 9 11.78 9 12C9 13.66 10.34 15 12 15C12.22 15 12.44 14.97 12.65 14.92L14.2 16.47C13.53 16.8 12.79 17 12 17C9.24 17 7 14.76 7 12C7 11.21 7.2 10.47 7.53 9.8ZM11.84 9.02L14.99 12.17L15.01 12.01C15.01 10.35 13.67 9.01 12.01 9.01L11.84 9.02Z"
        fill="#323232"
      />
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.8571 15.6429H21.5V16.3571H16.8571H16.3571V16.8571V21.5H15.6429V16.8571V16.3571H15.1429H10.5V15.6429H15.1429H15.6429V15.1429V10.5H16.3571V15.1429V15.6429H16.8571Z"
        fill="#B270BE"
        stroke="#8388A6"
      />
      <circle cx="16" cy="16" r="15" stroke="#8388A6" strokeWidth="2" />
    </svg>
  );
};

export const AddSmallIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.85714 5.64286H11.5V6.35715H6.85714H6.35714V6.85715V11.5H5.64286V6.85715V6.35715H5.14286H0.5V5.64286H5.14286H5.64286V5.14286V0.500008H6.35714V5.14286V5.64286H6.85714Z"
        fill="#B270BE"
        stroke="#B270BE"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="15" stroke="#B270BE" strokeWidth="2" />
      <path
        d="M17.8297 13.3511L18.6474 14.1689L10.5952 22.2222H9.77753V21.4044L17.8297 13.3511ZM21.0293 8C20.8071 8 20.576 8.08889 20.4072 8.25778L18.7807 9.88444L22.1136 13.2178L23.74 11.5911C24.0867 11.2444 24.0867 10.6844 23.74 10.3378L21.6603 8.25778C21.4826 8.08 21.2604 8 21.0293 8ZM17.8297 10.8356L8 20.6667V24H11.3329L21.1626 14.1689L17.8297 10.8356Z"
        fill="#B270BE"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66667 11C4.84348 11 5.01305 10.9297 5.13807 10.8047C5.2631 10.6797 5.33333 10.5101 5.33333 10.3333V6.33331C5.33333 6.1565 5.2631 5.98693 5.13807 5.86191C5.01305 5.73688 4.84348 5.66665 4.66667 5.66665C4.48986 5.66665 4.32029 5.73688 4.19526 5.86191C4.07024 5.98693 4 6.1565 4 6.33331V10.3333C4 10.5101 4.07024 10.6797 4.19526 10.8047C4.32029 10.9297 4.48986 11 4.66667 11ZM11.3333 2.99998H8.66667V2.33331C8.66667 1.80288 8.45595 1.29417 8.08088 0.9191C7.70581 0.544027 7.1971 0.333313 6.66667 0.333313H5.33333C4.8029 0.333313 4.29419 0.544027 3.91912 0.9191C3.54405 1.29417 3.33333 1.80288 3.33333 2.33331V2.99998H0.666667C0.489856 2.99998 0.320286 3.07022 0.195262 3.19524C0.0702379 3.32027 0 3.48984 0 3.66665C0 3.84346 0.0702379 4.01303 0.195262 4.13805C0.320286 4.26308 0.489856 4.33331 0.666667 4.33331H1.33333V11.6666C1.33333 12.1971 1.54405 12.7058 1.91912 13.0809C2.29419 13.4559 2.8029 13.6666 3.33333 13.6666H8.66667C9.1971 13.6666 9.70581 13.4559 10.0809 13.0809C10.456 12.7058 10.6667 12.1971 10.6667 11.6666V4.33331H11.3333C11.5101 4.33331 11.6797 4.26308 11.8047 4.13805C11.9298 4.01303 12 3.84346 12 3.66665C12 3.48984 11.9298 3.32027 11.8047 3.19524C11.6797 3.07022 11.5101 2.99998 11.3333 2.99998ZM4.66667 2.33331C4.66667 2.1565 4.7369 1.98693 4.86193 1.86191C4.98695 1.73688 5.15652 1.66665 5.33333 1.66665H6.66667C6.84348 1.66665 7.01305 1.73688 7.13807 1.86191C7.2631 1.98693 7.33333 2.1565 7.33333 2.33331V2.99998H4.66667V2.33331ZM9.33333 11.6666C9.33333 11.8435 9.2631 12.013 9.13807 12.1381C9.01305 12.2631 8.84348 12.3333 8.66667 12.3333H3.33333C3.15652 12.3333 2.98695 12.2631 2.86193 12.1381C2.7369 12.013 2.66667 11.8435 2.66667 11.6666V4.33331H9.33333V11.6666ZM7.33333 11C7.51014 11 7.67971 10.9297 7.80474 10.8047C7.92976 10.6797 8 10.5101 8 10.3333V6.33331C8 6.1565 7.92976 5.98693 7.80474 5.86191C7.67971 5.73688 7.51014 5.66665 7.33333 5.66665C7.15652 5.66665 6.98695 5.73688 6.86193 5.86191C6.73691 5.98693 6.66667 6.1565 6.66667 6.33331V10.3333C6.66667 10.5101 6.73691 10.6797 6.86193 10.8047C6.98695 10.9297 7.15652 11 7.33333 11Z"
        fill="#8388A6"
      />
    </svg>
  );
};

export const ConfirmIcon = () => {
  return (
    <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#B270BE" />
      <path d="M13.6 20.6L9.4 16.4L8 17.8L13.6 23.4L25.6 11.4L24.2 10L13.6 20.6Z" fill="white" />
    </svg>
  );
};

export const CancelIcon = () => {
  return (
    <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="15" stroke="#B270BE" strokeWidth="2" />
      <path
        d="M23 10.41L21.59 9L16 14.59L10.41 9L9 10.41L14.59 16L9 21.59L10.41 23L16 17.41L21.59 23L23 21.59L17.41 16L23 10.41Z"
        fill="#B270BE"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.66683 1.27325L8.72683 0.333252L5.00016 4.05992L1.2735 0.333252L0.333496 1.27325L4.06016 4.99992L0.333496 8.72659L1.2735 9.66659L5.00016 5.93992L8.72683 9.66659L9.66683 8.72659L5.94016 4.99992L9.66683 1.27325Z"
        fill="white"
      />
    </svg>
  );
};

export const StarFullIcon = ({ fill }) => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0697 1.35872C10.4027 0.514571 11.5973 0.51457 11.9303 1.35872L14.2348 7.20186C14.3364 7.45958 14.5404 7.66359 14.7981 7.76523L20.6413 10.0697C21.4854 10.4027 21.4854 11.5973 20.6413 11.9303L14.7981 14.2348C14.5404 14.3364 14.3364 14.5404 14.2348 14.7981L11.9303 20.6413C11.5973 21.4854 10.4027 21.4854 10.0697 20.6413L7.76523 14.7981C7.66359 14.5404 7.45958 14.3364 7.20186 14.2348L1.35872 11.9303C0.514571 11.5973 0.51457 10.4027 1.35872 10.0697L7.20186 7.76523C7.45958 7.66359 7.66359 7.45958 7.76523 7.20186L10.0697 1.35872Z"
        fill={fill ?? "#B270BE"}
      />
    </svg>
  );
};

export const StarEmptyIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0697 1.35872C10.4027 0.514571 11.5973 0.51457 11.9303 1.35872L14.2348 7.20186C14.3364 7.45958 14.5404 7.66359 14.7981 7.76523L20.6413 10.0697C21.4854 10.4027 21.4854 11.5973 20.6413 11.9303L14.7981 14.2348C14.5404 14.3364 14.3364 14.5404 14.2348 14.7981L11.9303 20.6413C11.5973 21.4854 10.4027 21.4854 10.0697 20.6413L7.76523 14.7981C7.66359 14.5404 7.45958 14.3364 7.20186 14.2348L1.35872 11.9303C0.514571 11.5973 0.51457 10.4027 1.35872 10.0697L7.20186 7.76523C7.45958 7.66359 7.66359 7.45958 7.76523 7.20186L10.0697 1.35872Z"
        fill="#CCCCCC"
      />
    </svg>
  );
};
